"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onInteractionEvent = void 0;
const event_names_1 = require("../../event.names");
const ga_event_1 = require("../../helpers/ga-event");
const crypto_1 = require("../../helpers/crypto");
let page = "(not set)";
function onInteractionEvent(eventPage) {
    page = eventPage;
    document.removeEventListener(event_names_1.eventNames.interactionCreated, onInteractionCreated);
    document.addEventListener(event_names_1.eventNames.interactionCreated, onInteractionCreated);
}
exports.onInteractionEvent = onInteractionEvent;
function onInteractionCreated(event) {
    return __awaiter(this, void 0, void 0, function* () {
        console.log(event);
        const interaction = event.detail.newInteraction.data;
        console.log(interaction);
        // userkey -> GA
        (0, ga_event_1.setUser)(interaction.userkey);
        // transaction -> GA
        (0, ga_event_1.customEvent)({
            transactionId: interaction.id,
            transactionTotal: 0,
            transactionProducts: [
                {
                    sku: "I" + interaction.id,
                    name: "Assisted",
                    category: "Agent Compare",
                    price: 0,
                    quantity: 1,
                },
            ],
        }, "transaction");
        // push conversion
        (0, ga_event_1.customEvent)({
            eventCallback: typeof interaction.eventCallback != "undefined"
                ? interaction.eventCallback
                : null,
        }, "gtm.interaction_created");
        (0, ga_event_1.customEvent)({
            leadsUserData: {
                sha256_email_address: yield (0, crypto_1.default)(interaction.email.trim()),
                address: {
                    sha256_street: yield (0, crypto_1.default)(interaction.streetaddress),
                    postal_code: interaction.postcode
                },
            },
        }, "formSubmitted");
        (0, ga_event_1.createEvent)({
            eventPage: page,
            eventCategory: "",
            eventSubCategory: "",
            eventAction: "",
            eventLabel: "",
            eventValueType: "InteractionId",
            eventValue: interaction.id,
            event_name: "conversion",
            sendGA3: false,
        });
    });
}
